export default function Layout(theme) {
  return {
    colorBgHeader: theme.palette.light.colorBgBase,
    controlHeightLG: 16
  }
}
